<div class="d-flex align-items-center spacing-8" [class.align-items-start]="description">
  <!-- <label [for]="id" [class.d-none]="lock"></label> -->
  <input
    class="form-check-input m-0 checkbox"
    [class.checkbox-small]="size === 'small'"
    [ngClass]="{ 'd-none': lock == true }"
    aria-label="checkbox"
    type="checkbox"
    [id]="id"
    [indeterminate]="indeterminate"
    [attr.name]="input_name"
    [checked]="checked"
    [disabled]="disabled"
    (change)="handleChange($event)"
    (click)="onClick($event)"
    (blur)="handleBlur()" />
  @if (lock == true) {
    <span
      class="d-flex lock-icon"
      [matTooltip]="title"
      [matTooltipPosition]="'above'"
      aria-describedby="lock-tooltip">
      <app-ce-icon [name]="'lock'" [svg_class]="['d-flex', 'primary-100']"></app-ce-icon>
    </span>
  }
  <div class="d-flex flex-column spacing-4 align-items-start">
    <label
      class="h4-bold primary-100"
      [class.code-font]="codeFont"
      [for]="id"
      [class.d-none]="lock">
      {{ label }}
    </label>
    @if (description) {
      <span class="h4-reg primary-60">{{ description }}</span>
    }
  </div>
</div>
